<div>
  @if (editMode && fieldConfig !== undefined && !editReadOnly) {
    <mat-form-field>
      @if (lookupCode !== 'image') {
        <div data-id="editWidgetField" [innerHtml]="label"></div>
      }
      @if (lookupCode !== 'image') {
        <input
          [hidden]="true"
          matInput
          [(ngModel)]="label"
          class="input-pointer"
          [errorStateMatcher]="matcher"
          #ngModel="ngModel" />
        @for (v of fieldConfig ? fieldConfig.validators : []; track v) {
          <mat-error>
            @if (condition(v, ngModel)) {
              <span>{{ message(v) }}</span>
            }
          </mat-error>
        }
      }
      @if (lookupCode === 'image' && !imageSrc) {
        <input matInput [(ngModel)]="label" class="input-pointer" [errorStateMatcher]="matcher" #ngModel="ngModel" />
        @for (v of fieldConfig ? fieldConfig.validators : []; track v) {
          <mat-error>
            @if (condition(v, ngModel)) {
              <span>{{ message(v) }}</span>
            }
          </mat-error>
        }
      }
      @if (lookupCode === 'image' && imageSrc) {
        <input matInput [(ngModel)]="label" #ngModel="ngModel" />
        <img [src]="imageSrc" class="small-image" />
        @for (v of fieldConfig ? fieldConfig.validators : []; track v) {
          <mat-error>
            @if (condition(v, ngModel)) {
              <span>{{ message(v) }}</span>
            }
          </mat-error>
        }
      }
      @if (editMode) {
        <mat-icon data-id="editFieldBtn" matSuffix class="icon-pointer" matTooltip="Select" (click)="openModal()"
          >mode_edit
        </mat-icon>
      }
      @if (editMode) {
        <mat-icon data-id="clearBtn" matSuffix class="icon-pointer" matTooltip="Clear" (click)="clearField()"
          >clear
        </mat-icon>
      }
    </mat-form-field>
  } @else {
    @if (externalUrl) {
      <a href="{{ externalUrl }}" target="_blank" class="element-inline">
        @if (lookupCode !== 'image') {
          <div [innerHtml]="this.label" class="element-inline"></div>
        }
        @if (lookupCode === 'image' && !imageSrc) {
          <div class="element-inline">No Image</div>
        }
        @if (lookupCode === 'image' && imageSrc) {
          <img [src]="imageSrc" class="small-image" class="element-inline" />
        }
      </a>
    } @else {
      @if (lookupCode !== 'image' && !showIcon) {
        <div [innerHtml]="this.label" data-id="inputValue" class="element-inline"></div>
      }
      @if (lookupCode === 'image' && !imageSrc && !showIcon) {
        <div class="element-inline">No Image</div>
      }
      @if (lookupCode === 'image' && imageSrc && !showIcon) {
        <img [src]="imageSrc" class="small-image" class="element-inline" />
      }
      @if (showIcon) {
        <div>
          <img [src]="icon" class="small-image" />
          @if (data?.name && data.name.length <= 15) {
            <div>{{ data.name }}</div>
          }
        </div>
      }
      @if (!showIcon && data) {
        <mat-icon
          matSuffix
          class="clipboard-copy"
          [ngClass]="{ 'clipboard-copied': this.clipboardCopied }"
          matTooltip="Copy to clipboard"
          (click)="copyToClipboard()"
          >file_copy
        </mat-icon>
      }
    }
    @if (externalUrl && data) {
      <mat-icon
        matSuffix
        class="clipboard-copy"
        [ngClass]="{ 'clipboard-copied': this.clipboardCopied }"
        matTooltip="Copy to clipboard"
        (click)="copyToClipboard()"
        >file_copy
      </mat-icon>
    }
    <!-- *ngIf="showClipboard" -->
  }
</div>
